export class Boolean {
  public static readonly True: BooleanValue = 0
  public static readonly False: BooleanValue = 1
  public static readonly NotAssigned: BooleanValue = 2
}

export declare type BooleanValue = 0 | 1 | 2
